<template>
  <v-container fluid>
    <v-layout justify-center>
      <v-card width="100%" >
      <v-flex lg12 pa-5 >
        <v-layout>
          <h2 class="primary--text text-uppercase textoAjustado text-center">
            {{localization.selectPromocion.title}}
          </h2>
        </v-layout>
        <v-divider class="divider_subtitle"></v-divider>

        <v-layout wrap justify-center>
          <v-flex xs12 sm12 md8 lg8 pl-3 pr-3>
          <v-autocomplete 
            :no-data-text="$t('sinDatos')"
            v-model="promoSelectedId" 
            id="promocion"
            :items="promociones" 
            item-text="name"
            item-value="id" 
            @change="getClientesEspByPromo()"
            :label="localization.selectPromocion.promocion"
          >
            <template v-slot:selection="data">
              {{ pintarPromocion(data) }}
            </template>
            <template v-slot:item="data">
              {{ pintarPromocion(data) }}
            </template>
          </v-autocomplete>
          </v-flex>
        </v-layout>

        <v-layout>
          <h2 class="primary--text text-uppercase textoAjustado text-center">
            {{localization.list.title}}
          </h2>
        </v-layout>
        <v-divider class="divider_subtitle"></v-divider>
        <v-form v-model="valid" id="valid" ref="form">
          <v-data-table
            :headers="headers"
            :items="specialClientesPorPromo"
            class="elevation-1"
            :loading="loading"
            
            :footer-props="{
              'items-per-page-options': [5, 10, 15, 20],
              'items-per-page-text': $t('filasPorPagina'),
            }"
          >
            <template v-slot:body="{ items }">
              <tbody>
                <tr v-for="item in items" :key="item.id">
                  <td class="text-xs-center">
                    <v-text-field :label="localization.list.codigo" :disabled="!item.checked"
                      v-model="item.codigo" id="codigo" @keypress="isNumber($event)" maxlength="11" readonly>
                    </v-text-field>
                  </td>
                  <td class="text-xs-center">
                    <v-text-field :label="localization.list.descripcion" :disabled="!item.checked"
                      :value="traducirClienteEspecial(item)" readonly>
                    </v-text-field>
                  </td>
                  <td class="text-xs-center" v-if="!comprobarTraduccionNombre(item)">
                    <v-text-field :label="localization.list.nombre" :disabled="!item.checked"
                      v-model="item.nombre" id="nombre" :rules="item.checked ? [rules.obligatorio] : true">
                    </v-text-field>
                  </td>
                  <td class="text-xs-center" v-if="comprobarTraduccionNombre(item)">
                    <v-text-field :label="localization.list.nombre" :disabled="!item.checked"
                      v-model="item.translates[usuario.idioma]" id="nombre" :rules="item.checked ? [rules.obligatorio] : true">
                    </v-text-field>
                  </td>
                  <td class="text-xs-center">
                    <v-text-field :label="localization.list.telefono" :disabled="!item.checked"
                      v-model="item.telefono" id="telefono" :rules="item.checked ? [rules.phoneNumber] : true">
                    </v-text-field>
                  </td>
                  <td class="text-xs-center">
                    <v-text-field :label="localization.list.movil" :disabled="!item.checked"
                      v-model="item.movil" id="movil" :rules="item.checked ? [rules.phoneNumber] : true">
                    </v-text-field>
                  </td>
                  <td class="text-xs-center">
                    <v-text-field :label="localization.list.email" :disabled="!item.checked"
                      v-model="item.email" id="email" :rules="item.checked ? [rules.email, rules.required] : true">
                    </v-text-field>
                  </td>
                  <td class="text-xs-center">
                    <v-text-field :label="localization.list.observaciones" :disabled="!item.checked"
                      v-model="item.observaciones" id="observaciones">
                    </v-text-field>
                  </td>
                  <td class="text-xs-center">
                    <v-checkbox v-model="item.checked" id="checked" :disabled="idubapi.restriccionesCliente.restringirEdicionMaestrosPV == 1"></v-checkbox>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-data-table>
        </v-form>
        <v-layout row mt-5>
          <v-flex pa-5>
            <v-btn 
              color="primary" 
              @click="updateChecks(specialClientesPorPromo)" 
              right :disabled="(idubapi.restriccionesCliente.restringirEdicionMaestrosPV == 1) || (Boolean(specialClientesPorPromo.length <= 0))"
            >
              {{localization.asignarButton}}
            </v-btn>
          </v-flex>
        </v-layout>
      </v-flex>
      </v-card>
    </v-layout>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import inputNumber from '@/mixins/inputNumber'
import rulesMixin from '@/components/generic/rules.js'

export default {
  mixins: [inputNumber, rulesMixin],
  data () {
    return {
      codigo: null,
      nombreClienteEspecial: '',
      loader: null,
      loading: false,
      promoSelectedId: [],
      valid: true
    }
  },
  computed: {
    ...mapGetters({
      idubapi: 'login/idubapi'
    }),
    headers () {
      return [
        { text: this.localization.list.codigo, value: 'codigo', sortable: true, align: 'left' },
        { text: this.localization.list.descripcion, value: 'descripcion', sortable: true, align: 'left' },
        { text: this.localization.list.nombre, value: 'nombre', sortable: true, align: 'left' },
        { text: this.localization.list.telefono, value: 'telefono', sortable: true, align: 'left' },
        { text: this.localization.list.movil, value: 'movil', sortable: true, align: 'left' },
        { text: this.localization.list.email, value: 'email', sortable: true, align: 'left' },
        { text: this.localization.list.observaciones, value: 'observaciones', sortable: true, align: 'left' },
        { text: this.localization.list.seleccionar, value: 'delete', sortable: false, align: 'center' }
      ]
    },
    localization () {
      return this.$t('maestros.clientesEspecialesPorPromocion')
    },
    /*promociones () {
      if (this.$store.state.incidencias.promociones) {
        return this.$store.state.incidencias.promociones
      }
      return []
    },
    */
    promociones () {
      if (this.$store.state.incidencias.promociones) {
        return this.$store.state.incidencias.promociones.map(x => {
          return {
            ...x,
            nombreCompleto: x.code + ' - ' + x.name
          }
        })
      }
      return []
    },
    specialClientesPorPromo () {
      if (this.$store.state.incidencias.clientesEspPorPromo && this.promoSelectedId.length > 0) {
        // return this.$store.state.incidencias.clientesEspPorPromo
        console.log(this.$store.state.incidencias.clientesEspPorPromo)
        return this.sortItemsByField(this.$store.state.incidencias.clientesEspPorPromo,'descripcion')
      }
      return []
    },
    translates() {
      if (this.$store.state.incidencias.translates) {
        return this.$store.state.incidencias.translates;
      }
      return [];
    },
    usuario() {
      return JSON.parse(localStorage.getItem('usuario'))
    }
  },
  mounted () {
    this.getPropertiesDevelopment()
  },
  beforeRouteLeave (to, from, next) {
    this.$store.commit('incidencias/setClientesEspByPromo', [])
    next()
  },
  methods: {
    ...mapActions({
      addAlert: 'alerts/add',
      getPropertiesDevelopment: 'incidencias/getPropertiesDevelopment',
      getClientesEspecialesByPromo: 'incidencias/getClientesEspecialesByPromo',
      addClientesEspByPromo: 'incidencias/addClientesEspByPromo',
      delClientesEspByPromo: 'incidencias/delClientesEspByPromo'
    }),
    getClientesEspByPromo () {
      this.loading = true
      this.$store.commit('incidencias/setSelectedPromoId', this.promoSelectedId)
      this.getClientesEspecialesByPromo(this.promoSelectedId)
        .then(() => {
          this.loading = false
        })
    },
    updateChecks (items) {
      this.$refs.form.validate()
      if (!this.valid) {
        this.addAlert({texto: this.$t("revisarCamposRojo"), color: 'error'})
      } else {
        this.loader = this.$loading.show({
          // Optional parameters
          container: this.fullPage ? null : this.$refs.formContainer,
          canCancel: false,
          onCancel: this.onCancel
        })
        const itemsChecked = []
        const itemsUnchecked = []
        let promoSelectedId = this.promoSelectedId
        if(typeof promoSelectedId === "object"){
          promoSelectedId = this.promoSelectedId[0]
        }
        items.map(e => {
          if (e.checked === false) {
            itemsUnchecked.push({
              idCliente: e.id,
              idPromocion: promoSelectedId,
              idClientePromocion: e.idRelacion,
              inputName: e.nombre,
              inputTelf: e.telefono,
              inputMovil: e.movil,
              inputEmail: e.email,
              inputObs: e.observaciones
            })
          } else {
            itemsChecked.push({
              idCliente: e.id,
              idPromocion: promoSelectedId,
              idClientePromocion: e.idRelacion,
              inputName: e.nombre,
              inputTelf: e.telefono,
              inputMovil: e.movil,
              inputEmail: e.email,
              inputObs: e.observaciones
            })
          }
        })
        this.addClientesEspByPromo(itemsChecked)
        this.delClientesEspByPromo(itemsUnchecked)
        this.loader.hide()
        this.addAlert({texto: this.$t('cambiosGuardados'), color: 'success'})
      }
    },
    pintarPromocion(item) {
      let datosPromocion = item.item
      return (this.idubapi.motor === 'SQLSERVER') ? datosPromocion.name + ' - ' + datosPromocion.code : datosPromocion.code + ' - ' + datosPromocion.name
    },
    traducirClienteEspecial (item) {
      if(this.usuario.idioma === 'spa') {
        return item.descripcion
      } else {
        let traducciones = item.translates
        if(traducciones) {
          return traducciones[this.usuario.idioma] || item.descripcion
        } else {
          return item.descripcion
        } 
      }
    },
    comprobarTraduccionNombre(item){
      if((item.translates[this.usuario.idioma] || "") !== ''){
        return true;
      }
      return false;
    },
    sortItemsByField(items, field){
     let lista = [...items]

      return lista.sort(function (a, b) {
        if(a === null || typeof a[field] === "undefined" || a[field] === null){
          return 1
        }
        if(b === null || typeof b[field] === "undefined" || b[field] === null){
          return -1
        }
        let x = a[field].trim().toLowerCase()
        let y = b[field].trim().toLowerCase()
        if (x > y) {
          return 1
        }
        if (x < y) {
          return -1
        }
        return 0
      });
    }
  }
}
</script>

<style scoped>
.iconSize {
  width: 16px !important;
}
</style>
